import { Route } from "react-router-dom";
import { AmwayIdLogin } from "../components/Authentication/AmwayIDLogin";
import { EntraLogin } from "../components/Authentication/EntraLogin";
import { EntraReceiver } from "../components/Authentication/Receiver/EntraReceiver";
import { ErrorPage } from "../components/ErrorPage/ErrorPage";
import { HeadlessImpersonation } from "../components/Authentication/HeadlessImpersonation";
import { JwtReceiver } from "../components/Authentication/Receiver/JWTReceiver";
import { Impersonation } from "../components/Authentication/ImpersonationPage/Impersonation";
import { MasheryReceiver } from "../components/Authentication/Receiver/MasheryReceiver";
import { AccountSelector } from "../components/Authentication/AccountSelector/AccountSelector";
import { MaintenancePage } from "../components/Maintenance/Maintenance";
import { AcademyAuthPage } from "../components/Academy/AcademyAuthPage/AcademyAuthPage";
import { NavDropdownMin } from "../common/interfaces/routing";

export enum AUTH_ROUTE_PATHS {
  AMWAY_ID_LOGIN = "/amway-id-login.html",
  AMWAY_ID_JWT_TOKEN = "/amway-id-jwt-token.html",
  ENTRA_LOGIN = "/entra-login.html",
  ENTRA_JWT_TOKEN = "/entra-jwt-token.html",
  IMPERSONATE = "/impersonate.html",
  MESSAGE = "/message/:code",
  JWT_RECEIVER = "/jwt-receiver.html",
  TOKEN_RECEIVER = "/token.html",
  IMPERSONATION = "/impersonation.html",
  ACCOUNT_SELECTOR = "/business-selector",
  MAINTENANCE = "/maintenance",
  ACADEMY_AUTH = "/academy/auth",
}

const AUTH_COMPONENT_MAP = {
  [AUTH_ROUTE_PATHS.AMWAY_ID_LOGIN]: <AmwayIdLogin />,
  [AUTH_ROUTE_PATHS.AMWAY_ID_JWT_TOKEN]: <JwtReceiver />,
  [AUTH_ROUTE_PATHS.ENTRA_LOGIN]: <EntraLogin />,
  [AUTH_ROUTE_PATHS.ENTRA_JWT_TOKEN]: <EntraReceiver />,
  [AUTH_ROUTE_PATHS.IMPERSONATE]: <HeadlessImpersonation />,
  [AUTH_ROUTE_PATHS.MESSAGE]: <ErrorPage />,
  [AUTH_ROUTE_PATHS.JWT_RECEIVER]: <JwtReceiver />,
  [AUTH_ROUTE_PATHS.TOKEN_RECEIVER]: <MasheryReceiver />,
  [AUTH_ROUTE_PATHS.IMPERSONATION]: <Impersonation />,
  [AUTH_ROUTE_PATHS.ACCOUNT_SELECTOR]: <AccountSelector />,
  [AUTH_ROUTE_PATHS.MAINTENANCE]: <MaintenancePage />,
  [AUTH_ROUTE_PATHS.ACADEMY_AUTH]: <AcademyAuthPage />,
};

export const AuthenticationRoutes = () => {
  return (
    <>
      {Object.entries(AUTH_COMPONENT_MAP).map(([path, element]) => (
        <Route key={path} path={path} element={element} />
      ))}
    </>
  );
};

export const AUTH_ROUTE_PATHS_ARRAY: string[] = Object.values(AUTH_ROUTE_PATHS);

enum AUTH_ROUTE_LABELS {
  AMWAY_ID_LOGIN = "amway-id-login",
  AMWAY_ID_JWT_TOKEN = "amway-id-jwt-token",
  ENTRA_LOGIN = "entra-login",
  ENTRA_JWT_TOKEN = "entra-jwt-token",
  IMPERSONATE = "impersonate",
  MESSAGE = "message",
  JWT_RECEIVER = "jwt-receiver",
  TOKEN_RECEIVER = "token",
  IMPERSONATION = "impersonation",
  ACCOUNT_SELECTOR = "business-selector",
  MAINTENANCE = "maintenance",
}

enum AUTH_ROUTE_GROUP_KEYS {
  IMPERSONATION = "impersonation",
}

export const authRoutes: NavDropdownMin[] = [
  {
    key: AUTH_ROUTE_GROUP_KEYS.IMPERSONATION,
    label: AUTH_ROUTE_GROUP_KEYS.IMPERSONATION,
    items: [
      {
        label: AUTH_ROUTE_LABELS.AMWAY_ID_LOGIN,
        path: AUTH_ROUTE_PATHS.AMWAY_ID_LOGIN,
      },
      {
        label: AUTH_ROUTE_LABELS.AMWAY_ID_JWT_TOKEN,
        path: AUTH_ROUTE_PATHS.AMWAY_ID_JWT_TOKEN,
      },
      {
        label: AUTH_ROUTE_LABELS.ENTRA_LOGIN,
        path: AUTH_ROUTE_PATHS.ENTRA_LOGIN,
      },
      {
        label: AUTH_ROUTE_LABELS.ENTRA_JWT_TOKEN,
        path: AUTH_ROUTE_PATHS.ENTRA_JWT_TOKEN,
      },
      {
        label: AUTH_ROUTE_LABELS.IMPERSONATE,
        path: AUTH_ROUTE_PATHS.IMPERSONATE,
      },
      {
        label: AUTH_ROUTE_LABELS.MESSAGE,
        path: AUTH_ROUTE_PATHS.MESSAGE,
      },
      {
        label: AUTH_ROUTE_LABELS.JWT_RECEIVER,
        path: AUTH_ROUTE_PATHS.JWT_RECEIVER,
      },
      {
        label: AUTH_ROUTE_LABELS.TOKEN_RECEIVER,
        path: AUTH_ROUTE_PATHS.TOKEN_RECEIVER,
      },
      {
        label: AUTH_ROUTE_LABELS.IMPERSONATION,
        path: AUTH_ROUTE_PATHS.IMPERSONATION,
      },
      {
        label: AUTH_ROUTE_LABELS.ACCOUNT_SELECTOR,
        path: AUTH_ROUTE_PATHS.ACCOUNT_SELECTOR,
      },
      {
        label: AUTH_ROUTE_LABELS.MAINTENANCE,
        path: AUTH_ROUTE_PATHS.MAINTENANCE,
      },
    ],
  },
];
